export const USER_LOGGED_IN = 'USER_LOGGED_IN';
export const USER_LOGIN_FAILED = 'USER_LOGIN_FAILED';
export const USER_LOGGING_IN = 'USER_LOGGING_IN';
export const USER_LOGGING_OUT = 'USER_LOGGING_OUT';
export const USER_LOGGED_OUT = 'USER_LOGGED_OUT';

export const DOWNLOADS_REQUESTED = 'DOWNLOADS_REQUESTED';
export const DOWNLOADS_RETRIEVED = 'DOWNLOADS_RETRIEVED';
export const DOWNLOADS_FAILED = 'DOWNLOADS_FAILED';
export const DOWNLOADS_CHANGE_PAGE = 'DOWNLOADS_CHANGE_PAGE';

export const SUBSCRIPTION_REQUESTED = 'SUBSCRIPTION_REQUESTED';
export const SUBSCRIPTION_RETRIEVED = 'SUBSCRIPTION_RETRIEVED';
export const SUBSCRIPTION_FAILED = 'SUBSCRIPTION_FAILED';
export const SUBSCRIPTION_CHANGE_PAGE = 'SUBSCRIPTION_CHANGE_PAGE';

export const CATEGORIES_REQUESTED = 'CATEGORIES_REQUESTED';
export const CATEGORIES_RETRIEVED = 'CATEGORIES_RETRIEVED';
export const CATEGORIES_FAILED = 'CATEGORIES_FAILED';
export const CATEGORIES_CHANGE_PAGE = 'CATEGORIES_CHANGE_PAGE';

export const CHANGE_CATEGORY = 'CHANGE_CATEGORY';
export const CAT_ARTICLES_REQUESTED = 'CAT_ARTICLES_REQUESTED';
export const CAT_ARTICLES_RETRIEVED = 'CAT_ARTICLES_RETRIEVED';
export const CAT_ARTICLES_FAILED = 'CAT_ARTICLES_FAILED';
export const CAT_ARTICLES_CHANGE_PAGE = 'CAT_ARTICLES_CHANGE_PAGE';

export const DOCUMENT_REQUESTED = 'DOCUMENT_REQUESTED';
export const DOCUMENT_RETRIEVED = 'DOCUMENT_RETRIEVED';
export const DOCUMENT_FAILED = 'DOCUMENT_FAILED';

export const OPEN_MOBILE_MENU = 'OPEN_MOBILE_MENU';
export const CLOSE_MOBILE_MENU = 'CLOSE_MOBILE_MENU';



// WEBPACK FOOTER //
// ./src/constants/action.types.ts